export const turboInsights = () => {
    return {
        query: null,
        category: null,
        submit(form) {
            let params = [];

            if (this.query) {
                params.push(`q=${encodeURIComponent(this.query)}`);
            }

            if (this.category) {
                params.push(`cat=${encodeURIComponent(this.category)}`)
            }

            let q = window.location.pathname;

            if (params.length) {
                q += '?' + params.join('&');
            }

            fetch(q, {method: 'GET'})
                .then(function (response) {
                    if (response.ok) {
                        return response.text();
                    }

                    return Promise.reject(response);
                })
                .then(function (html) {
                    return (new DOMParser()).parseFromString(html, 'text/html').querySelector('.container.posts');
                })
                .then(function (posts) {
                    this.$refs.posts.innerHTML = posts.innerHTML;
                }.bind(this))
                .then(function () {
                    window.history.pushState(null, '', q);
                })
                .catch(function (err) {
                    console.log(err);
                })
            ;
        }
    }
}
